import { useEffect, useState } from "react";
import { api } from "@/lib/api";
import Topbar from "@/components/layout/Topbar";
import { formatDate } from "@/lib/format";
import { useTranslation } from "react-i18next";

export default function SuperProperties() {
    const { t } = useTranslation();
    const [items, setItems] = useState([]);
    const [search, setSearch] = useState("");

    useEffect(() => { api.get("/admin/properties").then(({ data }) => setItems(data)); }, []);

    const filtered = items.filter((p) =>
        !search || p.name.toLowerCase().includes(search.toLowerCase()) ||
        (p.hotel_name || "").toLowerCase().includes(search.toLowerCase()) ||
        (p.city || "").toLowerCase().includes(search.toLowerCase())
    );

    return (
        <>
            <Topbar title={t("super_admin.properties_title")} subtitle={`${items.length} ${t("common.total")}`} />
            <div className="flex-1 overflow-auto p-6">
                <input
                    value={search}
                    onChange={(e) => setSearch(e.target.value)}
                    placeholder="Search by name, hotel, city…"
                    className="akm-input mb-3 max-w-md"
                />
                <div className="akm-card overflow-hidden">
                    <table className="akm-table w-full">
                        <thead><tr><th>Hotel</th><th>Property</th><th>City</th><th>Country</th><th>Currency</th><th>Timezone</th><th>Created</th></tr></thead>
                        <tbody>
                            {filtered.map((p) => (
                                <tr key={p.id}>
                                    <td className="font-medium">{p.hotel_name}</td>
                                    <td>{p.name}</td>
                                    <td>{p.city || "—"}</td>
                                    <td>{p.country || "—"}</td>
                                    <td className="font-mono text-[12px]">{p.currency}</td>
                                    <td className="text-muted-foreground">{p.timezone}</td>
                                    <td className="text-muted-foreground">{formatDate(p.created_at)}</td>
                                </tr>
                            ))}
                            {filtered.length === 0 && <tr><td colSpan="7" className="py-12 text-center text-muted-foreground">No properties</td></tr>}
                        </tbody>
                    </table>
                </div>
            </div>
        </>
    );
}
